import { render, staticRenderFns } from "./ManagePlantVariety.vue?vue&type=template&id=553874d0&"
import script from "./ManagePlantVariety.vue?vue&type=script&lang=js&"
export * from "./ManagePlantVariety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports